import type { PublicAuction } from "./types";

/** Full bid history — from authenticated REST endpoint */
export type AuctionBidHistoryItem = {
  bidId: string;
  bidderOrganizationId: string;
  bidderName?: string | null;
  bidderNumber: number;
  amount: number;
  createdAt: string;
  isAutoBid: boolean;
  sellerPayout: number;
};

/** Sanitized bid — from public SSE events */
export type PublicBidHistoryItem = {
  bidId: string;
  bidderNumber: number;
  amount: number;
  createdAt: string;
  isAutoBid: boolean;
};

export type AuctionOffer = {
  id: string;
  round: number;
  offeredBy: "seller" | "buyer" | string;
  amount: number;
  notes: string | null;
  status: string;
  createdAt: string;
  sellerPayout: number;
  buyerPrice: number;
};

export type AuctionSnapshotEvent = {
  type: "auction.snapshot";
  auctionId: string;
  currentBid: number;
  bidCount: number;
  endsAt: string | null;
  extendedCount: number;
  highestBidderOrganizationId?: string | null;
  latestBid: PublicBidHistoryItem | null;
  bidHistory: PublicBidHistoryItem[];
  minimumIncrement: number;
  serverTime: string;
  status?: string;
};

export function applyAuctionSnapshotToPublicAuction(
  auction: PublicAuction,
  event: AuctionSnapshotEvent,
): PublicAuction {
  if (auction.id !== event.auctionId) {
    return auction;
  }

  return {
    ...auction,
    currentBid: event.currentBid,
    bidCount: event.bidCount,
    endsAt: event.endsAt,
    minimumIncrement: event.minimumIncrement,
    status: event.status ?? auction.status,
    highestBidderOrganizationId: event.highestBidderOrganizationId ?? auction.highestBidderOrganizationId,
  };
}
